import { useEffect, useState } from 'react';
import CiselnikPolozka from '../../../model/CiselnikPolozka';
import { ClientStatus } from '../../../model/ClientStatus';
import { CiselnikPolozkaFilterSearch } from '../../../model/CiselnikPolozkaFilterSearch';
import { useClient } from '../../../context/ClientStatusContext';
import { fetchCiselnikPolozky } from '../../../client/external/ciselnikPolozkaClient';

interface ReturnType {
  polozkyCiselnik: CiselnikPolozka[];
  polozkyCiselnikStatus: ClientStatus;
}

export default (
  searchParams: CiselnikPolozkaFilterSearch,
): ReturnType => {
  const {
    hladanyNazov, kody, limit, platny, typy, ids,
  } = searchParams;
  const [, setAction] = useState(0);
  const { wrapClient, status, data } = useClient(fetchCiselnikPolozky);

  useEffect(() => {
    setAction(prevState => {
      clearTimeout(prevState);
      return prevState;
    });

    const act = setTimeout(async () => {
      await wrapClient(ids, typy, platny, hladanyNazov, kody, limit);
    }, 300);

    // @ts-ignore
    setAction(act);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hladanyNazov, limit]);

  return {
    polozkyCiselnik: data || [],
    polozkyCiselnikStatus: status,
  };
};
